export default __webpack_public_path__ + "static/2-8de0da56d419070f3091b299c8bd0ecb.png";